// https://github.com/lodash/lodash/blob/master/.internal/baseGet.js
export const get = (
  object: Record<string, any>,
  path: (string | number)[],
): any => {
  const length = path.length;
  let currentObj: any = object;
  let index = 0;
  while (
    currentObj !== null &&
    typeof currentObj !== "undefined" &&
    index < length
  ) {
    currentObj = currentObj[path[index]];
    index++;
  }
  return index !== 0 && index === length ? currentObj : undefined;
};
